module.exports = __webpack_public_path__ + "static/media/user.413338b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/DefaultLayout/components/NavBar/components/Tools/images/user.svg
// module id = 420
// module chunks = 17